import React, { useState } from 'react';

import { Container } from './styles';

export default function SelectButtons(props) {
  const buttons = props.buttons || ['Button1', 'Button2'];
  const { colors } = props;
  const { widthButton } = props;

  const [selectedItem, setSelectedItem] = useState(props.selectedIndex);
  const { onClick, style, className } = props;

  return (
    <Container className={className || {}} style={{ ...style }}>
      {buttons.map((e, idx) => montaBotao(e, idx))}
    </Container>
  );

  function montaBotao(elemet, idx) {
    const styleLocal = {};
    if (widthButton) {
      styleLocal.width = widthButton;
    } else {
      styleLocal.flex = 1;
    }

    if (idx !== selectedItem) {
      let classSelected = 'button-selected1';
      if (Array.isArray(colors) && colors[idx] >= 1 && colors[idx] <= 2) {
        classSelected = `button-unselected${colors[idx]}`;
      }
      return (
        <button
          key={idx}
          id={idx}
          className={classSelected}
          style={{ ...styleLocal }}
          onClick={() => {
            setSelectedItem(idx);
            if (onClick) {
              onClick(idx);
            }
          }}
        >
          {elemet}
        </button>
      );
    }

    return (
      <button
        key={idx}
        id={idx}
        className="button-selected"
        style={{ ...styleLocal }}
        onClick={() => {
          setSelectedItem(idx);
          if (onClick) {
            onClick(idx);
          }
        }}
      >
        {elemet}
      </button>
    );
  }
}
